<template>
  <q-slider
    v-bind="$attrs"
    @change="$emit('change', $event)"
    @pan="$emit('pan', $event)"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: 'AppSlider',
};
</script>
